module.exports = __webpack_public_path__ + "img/station.fc9af7ad.webp";